module.exports = __webpack_public_path__ + "media/images/icons/outlined/behance-0833e00ae7feff58072cb9acc8599745.svg";